import { STYLE_OPTIONS } from 'src/constants';

const color = '#393939';
const fontFamily = STYLE_OPTIONS.FONT_FAMILY;

const selectFieldToInsertStyle = (theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    border: `1px solid ${STYLE_OPTIONS.COLOR_LIGHT_GREY_2}`,
    width: 32,
    height: 32,
    boxSizing: 'border-box',
    padding: 0,
    backgroundColor: '#ebebeb',
    borderRadius: 4,
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',

    '&.withBtn': {
      padding: 0,

      '& .divBtn': {
        display: 'flex',
        width: 35,
        height: 50,
        alignItems: 'center',
        justifyContent: 'center',
      },
    },

    '& .MuiInputBase-root, & .MuiFormLabel-root': {
      fontSize: '14px',
    },
  },

  groupLabel: {
    color,
    fontFamily,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16px',
    padding: '0px 0px 10px 0px',
  },

  innerFieldDropDown: {
    position: 'absolute',
    display: 'block',
    top: 35,
    left: -356,
    width: 390,
    maxHeight: 500,
    padding: '16px',
    backgroundColor: '#ffffff',
    borderRadius: 4,
    border: `1px solid ${STYLE_OPTIONS.COLOR_LIGHT_GREY_2}`,
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    zIndex: 250,
    cursor: 'default',

    '& .buttonLine': {
      display: 'flex',
      justifyContent: 'flex-end',
      paddingBottom: 12,
      borderBottom: '1px solid #E0E0E0',

      '& .MuiButton-root': {
        ...STYLE_OPTIONS.BUTTON_PRIMARY,
        marginLeft: 8,

        '&.cancel': {
          ...STYLE_OPTIONS.BUTTON_SECONDARY,
        },

        '&.Mui-disabled': {
          opacity: 0.5,
        },
      },
    },

    '& .formBox': {
      paddingTop: 12,
    },

    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      display: 'block',
      top: 35,
      left: -216,
      width: 280,
      height: 'auto',
      padding: '16px',
    },
  },

  tabs: {
    minHeight: 36,
    marginBottom: 8,
    '& .MuiTab-root': {
      minHeight: 36,
      padding: '6px 12px',
      fontSize: '13px',
      textTransform: 'none',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: STYLE_OPTIONS.COLOR_BLUE,
    },
  },

  searchField: {
    marginBottom: 8,
    '& .MuiInputBase-root': {
      fontSize: '13px',
      height: 32,
    },
    '& .MuiInputBase-input': {
      padding: '6px 8px 6px 0',
    },
    '& .MuiInputAdornment-root': {
      marginRight: 4,
    },
    '& .MuiSvgIcon-root': {
      color: '#888',
      fontSize: 18,
    },
  },

  tabContent: {
    maxHeight: 320,
    overflowY: 'auto',
    border: '1px solid #E0E0E0',
    borderRadius: 4,
  },

  fieldList: {
    width: '100%',
    padding: 0,
  },

  sectionLabel: {
    display: 'block',
    padding: '8px 16px 4px',
    color: '#666',
    fontWeight: 600,
    backgroundColor: '#f9f9f9',
  },

  categoryHeader: {
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #e0e0e0',
    '&:hover': {
      backgroundColor: '#eeeeee',
    },
  },

  fieldItem: {
    borderBottom: '1px solid #f0f0f0',
    '&:last-child': {
      borderBottom: 'none',
    },
    '&.Mui-selected': {
      backgroundColor: 'rgba(88, 80, 236, 0.1)',
      '&:hover': {
        backgroundColor: 'rgba(88, 80, 236, 0.15)',
      },
    },
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
});

export default selectFieldToInsertStyle;
